import { makeRequired } from 'CorePackage/MainModule/validators/isRequired';
import { REQUIRED_ERROR } from 'CorePackage/MainModule/constants/validationErrors';

import { IErknmFormAgreementChange } from '../interfaces/IErknmFormAgreementChange';

export const getAgreementChangeValidate = (change: IErknmFormAgreementChange) => {
  return {
    types: change.types?.map(i => ({
      type: makeRequired(REQUIRED_ERROR)(i.type),
    })),
    reasons: change.reasons?.map(i => makeRequired(REQUIRED_ERROR)(i)),
    attachment: makeRequired(REQUIRED_ERROR)(change.attachment),
    termOfExecutionAgreement: change.types?.find(type => type.type?.value === 'EXTENSION_OF_DEADLINE')
      ? makeRequired(REQUIRED_ERROR)(change.termOfExecutionAgreement)
      : undefined,
    updatedAgreementAttachment: makeRequired(REQUIRED_ERROR)(change.updatedAgreementAttachment),
    petitionAttachment: makeRequired(REQUIRED_ERROR)(change.petitionAttachment),
    fioSigner: makeRequired(REQUIRED_ERROR)(change.fioSigner),
    titleSigner: makeRequired(REQUIRED_ERROR)(change.titleSigner),
  };
};
